import { SVGProps } from "react";

export default function MonitorIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#E3592E", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.5 14.375V15.2145C7.5 15.8775 7.23661 16.5134 6.76777 16.9822L6.25 17.5H13.75L13.2322 16.9822C12.7634 16.5134 12.5 15.8775 12.5 15.2145V14.375M17.5 4.375V12.5C17.5 13.5355 16.6605 14.375 15.625 14.375H4.375C3.33947 14.375 2.5 13.5355 2.5 12.5V4.375M17.5 4.375C17.5 3.33947 16.6605 2.5 15.625 2.5H4.375C3.33947 2.5 2.5 3.33947 2.5 4.375M17.5 4.375V10C17.5 11.0355 16.6605 11.875 15.625 11.875H4.375C3.33947 11.875 2.5 11.0355 2.5 10V4.375"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
